import BannersRequests from '../../server/banners';
import { addLoading, removeLoading } from './loading';

const setBanners = banners => ({
  type: 'GET_BANNERS',
  banners,
});

const setBanner = banner => ({
  type: 'GET_BANNER',
  banner,
});


const getBanners = (limit, skip, search = '', order = '', field = '') => async (dispatch) => {
  dispatch(addLoading());
  try {
    const banners = await BannersRequests.getBanners(limit, skip, search, order, field);
    dispatch(setBanners(banners));
  } finally {
    dispatch(removeLoading());
  }
};

const getBanner = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const banner = await BannersRequests.getBanner(id);
    dispatch(setBanner(banner));
  } finally {
    dispatch(removeLoading());
  }
};

const createBanner = banner => async (dispatch) => {
  dispatch(addLoading());
  try {
    await BannersRequests.createBanner(banner);
  } finally {
    dispatch(removeLoading());
  }
};

const updateBanner = (banner, noLoading = false) => async (dispatch) => {
  if (!noLoading) dispatch(addLoading());
  try {
    await BannersRequests.updateBanner(banner);
  } finally {
    if (!noLoading) dispatch(removeLoading());
  }
};

const deleteBanner = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await BannersRequests.deleteBanner(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvBannerModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await BannersRequests.getCsvBannerModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvBannersReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await BannersRequests.getCsvBannersReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadBannersCsv = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await BannersRequests.uploadCsvBanners(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

const uploadBanner = async (file, name, id) => BannersRequests.uploadBanner(file, name, id);

export const getBannerImage = fileUrl => async (dispatch) => {
  dispatch(addLoading());
  try {
    await BannersRequests.getBannerImage(fileUrl);
  } finally {
    dispatch(removeLoading());
  }
};


export default {
  getBanners,
  getBanner,
  createBanner,
  deleteBanner,
  updateBanner,
  uploadBanner,
  getCsvBannersReport,
  getBannerImage,
};
